import React from 'react';

type IconProps = {
    size?: string;
    d: string;
    className?: string;
    viewBox?: string;
    fill?: string;
    transform?: string;
    onClick?: () => any;
};

export default function Icon({
    size = '16',
    d,
    className,
    viewBox = '0 0 20 20',
    fill,
    transform,
    onClick,
}: IconProps) {
    const styles = {
        svg: {
            display: 'inline-block',
            verticalAlign: 'middle',
        },
    };

    return (
        <svg
            className={className}
            style={styles.svg}
            width={`${size}px`}
            height={`${size}px`}
            viewBox={viewBox}
            onClick={onClick}
        >
            <path fill={fill} d={d} transform={transform} />
        </svg>
    );
}
